module.exports = __webpack_public_path__ + "static/img/14000091.108912a0.png";